import React, { useState, useEffect } from "react";
import { TextField, Button, Container, Typography, Grid, Box } from "@mui/material";
import { LocalizationProvider, DateTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import axios from "axios";
import { Header } from "../0_layout/HeaderFooter";
import { Footer } from "../0_layout/Footer";
import { useParams } from 'react-router-dom';





const ContactForm = ({ image, id, courseName }) => {
  const { index } = useParams(); // 🟢 '1', '2', etc.
  const [selectedOffering, setSelectedOffering] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/weoffer`)
      .then(res => res.json())
      .then(data => {
        const found = data.find(item => item.index === Number(index));
        setSelectedOffering(found);
      })
      .catch(err => console.error("Failed to fetch offerings:", err));
  }, [index]);


  useEffect(() => {
    const fetchCourseByIndex = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/weoffer`);
        const matched = res.data.find(item => item.index === Number(index));
        if (matched) {
          setFormData((prev) => ({
            ...prev,
            courseName: matched.courseName,
          }));
        }
      } catch (error) {
        console.error("Error fetching course by index:", error);
      }
    };

    fetchCourseByIndex();
  }, [index]);
  const [formData, setFormData] = useState({
    name: "",
    school: "",
    city: "",
    email: "",
    contactNo: "",
    offeringType: "",
    offeringName: "",
    message: "",
    courseName: courseName,
    preferredDateTime: null,
  });

  const [errors, setErrors] = useState({
    name: false,
    email: false,
    contactNo: false,
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (field === "name" && value.trim() !== "") setErrors((prev) => ({ ...prev, name: false }));
    if (field === "email" && /\S+@\S+\.\S+/.test(value)) setErrors((prev) => ({ ...prev, email: false }));
    if (field === "contactNo" && /^\d{10}$/.test(value)) setErrors((prev) => ({ ...prev, contactNo: false }));
  };

  const handleSubmit = async (event) => {

    event.preventDefault();

    const newErrors = {
      name: formData.name.trim() === "",
      email: !/\S+@\S+\.\S+/.test(formData.email),
      contactNo: !/^\d{10}$/.test(formData.contactNo),
    };

    setErrors(newErrors);

    if (!newErrors.name && !newErrors.email && !newErrors.contactNo) {
      setLoading(true);
      try {
        const response = await axios.post(process.env.REACT_APP_API_URL + `/api/enquiry`, {
          name: formData.name,
          school: formData.school,
          city: formData.city,
          email: formData.email,
          contactNo: formData.contactNo,
          message: formData.message,
          offeringType: formData.offeringType,
          offeringName: formData.offeringName,
          courseName: formData.courseName,
          preferredDateTime: formData.preferredDateTime ? formData.preferredDateTime.toISOString() : null,
        });
        console.log("Submitting formData:", formData);

        console.log(formData);

        alert(response.data.message);
        setFormData({
          name: "",
          school: "",
          city: "",
          email: "",
          contactNo: "",
          message: "",
          offeringType: "",
          offeringName: "",
          preferredDateTime: null,
        });
      } catch (error) {
        console.error("Error submitting form:", error);
        alert("Failed to submit enquiry. Please try again.");
      } finally {
        setLoading(false);
      }
    }
  };

  const labelStyle = {
    color: 'grey',
    fontSize: '18px'
  };



  return (
    <><Header />
      <Container maxWidth="lg" sx={{ mb: 4, mt: 18, p: 3, bgcolor: "white", display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <Typography variant="h5" textAlign="center" mb={3}>
          Enquire
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {/* Name and School in the same row */}
            <Grid item xs={6}>
              <Typography variant="subtitle1" gutterBottom sx={labelStyle}>
                Name: <Box component="span" sx={{ color: 'red' }}>*</Box>
              </Typography>
              <TextField
                fullWidth
                placeholder="Enter your name"
                variant="outlined"
                value={formData.name}
                onChange={(e) => handleChange("name", e.target.value)}
                error={errors.name}
                helperText={errors.name ? "Name is required" : ""}
                size="small"
                sx={{
                  '& .MuiInputBase-input::placeholder': {
                    color: 'black',
                  }
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <Typography variant="subtitle1" gutterBottom sx={labelStyle}>
                School: <Box component="span" sx={{ color: 'red' }}>*</Box>
              </Typography>
              <TextField
                fullWidth
                placeholder="Enter your school"
                variant="outlined"
                value={formData.school}
                onChange={(e) => handleChange("school", e.target.value)}
                size="small"
                sx={{
                  '& .MuiInputBase-input::placeholder': {
                    color: 'black',
                  }
                }}
              />
            </Grid>

            {/* City and Email in the next row */}
            <Grid item xs={6}>
              <Typography variant="subtitle1" gutterBottom sx={labelStyle}>
                City: <Box component="span" sx={{ color: 'red' }}>*</Box>
              </Typography>
              <TextField
                fullWidth
                placeholder="Enter your city"
                variant="outlined"
                value={formData.city}
                onChange={(e) => handleChange("city", e.target.value)}
                size="small"
                sx={{
                  '& .MuiInputBase-input::placeholder': {
                    color: 'black',
                  }
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <Typography variant="subtitle1" gutterBottom sx={labelStyle}>
                Email: <Box component="span" sx={{ color: 'red' }}>*</Box>
              </Typography>
              <TextField
                fullWidth
                placeholder="Enter your email"
                variant="outlined"
                value={formData.email}
                onChange={(e) => handleChange("email", e.target.value)}
                error={errors.email}
                helperText={errors.email ? "Enter a valid email address" : ""}
                size="small"
                sx={{
                  '& .MuiInputBase-input::placeholder': {
                    color: 'black',
                  }
                }}
              />
            </Grid>

            {/* Phone Number in the next row */}
            <Grid item xs={12}>
              <Typography variant="subtitle1" gutterBottom sx={labelStyle}>
                Contact Number: <Box component="span" sx={{ color: 'red' }}>*</Box>
              </Typography>
              <TextField
                fullWidth
                placeholder="Enter your 10-digit contact number"
                variant="outlined"
                value={formData.contactNo}
                onChange={(e) => handleChange("contactNo", e.target.value)}
                error={errors.contactNo}
                helperText={errors.contactNo ? "Enter a valid 10-digit contact number" : ""}
                size="small"
                sx={{
                  '& .MuiInputBase-input::placeholder': {
                    color: 'black',
                  }
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <Typography variant="subtitle1" gutterBottom sx={labelStyle}>
                Offering Type: <Box component="span" sx={{ color: 'red' }}>*</Box>
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                value={selectedOffering?.type || ""}
                InputProps={{ readOnly: true }}
                size="small"
                sx={{ '& .MuiInputBase-input': { color: 'black' } }}
              />
            </Grid>

            <Grid item xs={6}>
              <Typography variant="subtitle1" gutterBottom sx={labelStyle}>
                Offering Name: <Box component="span" sx={{ color: 'red' }}>*</Box>
              </Typography>
              <TextField
                fullWidth
                variant="outlined"
                value={selectedOffering?.courseName || ""}
                InputProps={{ readOnly: true }}
                size="small"
                sx={{ '& .MuiInputBase-input': { color: 'black' } }}
              />
            </Grid>

            {/* Message in the next row */}
            <Grid item xs={12}>
              <Typography variant="subtitle1" gutterBottom sx={labelStyle}>
                Message: <Box component="span" sx={{ color: 'red' }}>*</Box>
              </Typography>
              <TextField
                fullWidth
                placeholder="Enter your message "
                variant="outlined"
                multiline
                rows={2}
                value={formData.message}
                onChange={(e) => handleChange("message", e.target.value)}
                sx={{
                  '& .MuiInputBase-input::placeholder': {
                    color: 'black',
                  }
                }}
              />
            </Grid>

            {/* Date Time Picker in the next row */}
            <Grid item xs={12}>
              <Typography variant="subtitle1" gutterBottom sx={labelStyle}>
                Preferred Date & Time: <Box component="span" sx={{ color: 'red' }}>*</Box>
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  label="Select preferred date and time"
                  value={formData.preferredDateTime}
                  onChange={(newValue) => handleChange("preferredDateTime", newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      size="small"
                      sx={{
                        '& .MuiInputBase-input::placeholder': {
                          color: 'black',
                        }
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            {/* Submit button in the last row */}
            <Grid item xs={12} textAlign="center">
              <Button type="submit" variant="contained" color="primary" sx={{ px: 5 }} disabled={loading}>
                {loading ? "Submitting..." : "Submit"}
              </Button>
            </Grid>
          </Grid>
        </form>
      </Container>
      <Footer />
    </>
  );
};

export default ContactForm;